import type { ListUserDetailsDTO } from '@bb/domain/dist/types';
import axios from 'axios';

type GetListingsByUserOptions = {
  userId: string;
  search?: string;
  page: number;
  pageSize?: number;
  includeAccess?: boolean;
  includeAllAvail?: boolean;
};

const getListingsByUser = async ({
  userId,
  search,
  page = 0,
  pageSize,
  includeAccess,
  includeAllAvail,
}: GetListingsByUserOptions) => {
  const includeAccessString: string = includeAccess
    ? '&includeAccess=true'
    : '';

  /**
   * Server defaults to availability = 'Available' for this endpoint if availablity not provided
   */
  const includeAllAvailString: string = includeAllAvail
    ? '&availability=All'
    : '';

  const { data } = await axios.get<ListUserDetailsDTO>(
    `/listing/by_user/${userId}?page=${page}&pageSize=${pageSize}${includeAccessString}${includeAllAvailString}&search=${search}`,
  );

  return data;
};

export default getListingsByUser;
